export const roundNumber = (value: string, decimals = 0) => {
  if (decimals > 0) return Number(Number(value).toFixed(decimals));
  return Math.round(Number(value));
};

export const formatPercentage = (value: number): string | number => {
  return roundNumber((Number(value) * 100).toString(), 0);
};

export const formatTemperature = (value: string) => {
  return `${roundNumber(value, 1)}`;
};

export const formatImpact = (value: number) => {
  return `${roundNumber(value.toString(), 1)}`;
};

export const formatDuration = (value: string) => {
  const hours = Math.floor(Number(value) / 60);
  const minutes = Math.floor(Number(value) % 60);
  const days = Math.floor(hours / 24);

  const format = (num: number) => num.toString().padStart(2, "0");

  if (days > 0) return `${days}:${format(hours % 24)}:${format(minutes)}`;

  return `${format(hours)}:${format(minutes)}`;
};

export const formatUnixTimestampToDate = (unixTimetamp: string) => {
  const date = new Date(Number(unixTimetamp) * 1_000);
  if (!date.getDate()) return "Invalid date";
  return date.toLocaleDateString() + " " + date.toLocaleTimeString();
};
